import React, { useState, useRef, useCallback, useEffect } from 'react';
import { Input } from '@nextui-org/react';

function DebouncedSearch({
  label,
  url,
  fetchFunction,
  debounceTime = 700,
  onSelect,
  renderItem,
  onClickLabel,
  startContent,
  placeholder,
  refresh
}) {
  const inputRef = useRef(null);
  const timeoutRef = useRef(null);
  const dropdownRef = useRef(null);
  const [results, setResults] = useState([]);
  const [inputValue, setInputValue] = useState("");

  const fetchResults = useCallback(async (query) => {
    if (!query.trim()) {
      setResults([]);
      dropdownRef.current?.classList.add("hidden");
      return;
    }

    const response = await fetchFunction(query);
    setResults(response);
    dropdownRef.current?.classList.remove("hidden");
  }, [url, fetchFunction]);


  useEffect(() => {
    const handleInput = (event) => {
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
      timeoutRef.current = setTimeout(() => fetchResults(event.target.value), debounceTime);
    };

    const inputElement = inputRef.current;
    inputElement?.addEventListener("input", handleInput);

    return () => inputElement?.removeEventListener("input", handleInput);
  }, [fetchResults, debounceTime]);

  useEffect(() => {
    clearItem()
  }, [refresh]);

  useEffect(() => {
    document.addEventListener("mousedown", onClickOutside);
    return () => {
      document.removeEventListener("mousedown", onClickOutside);
    };
  }, []);

  const onClickOutside = (event) => {
    if (
      dropdownRef.current &&
      !dropdownRef.current.contains(event.target) &&
      inputRef.current !== event.target
    ) {
      dropdownRef.current.classList.add("hidden");
    }
  };

  const onClickItem = (item) => {

    setInputValue(onClickLabel(item));

    dropdownRef.current.classList.add("hidden");
    onSelect(item);
  };

  const clearItem = () => {
    setInputValue("");
    dropdownRef.current.classList.add("hidden");
    onSelect(undefined);
  };

  return (
    <div className="relative w-full max-w-md">
      <Input
        label={label}
        value={inputValue}
        onChange={(e) => setInputValue(e.target.value)}
        ref={inputRef}
        placeholder={placeholder || 'Buscar...'}
        className="w-full"
        labelPlacement="outside"
        variant="bordered"
        isClearable
        startContent={startContent}
        onClear={clearItem}
        radius="sm"
      />
      <div
        ref={dropdownRef}
        className="absolute z-50 w-full bg-white shadow-lg rounded-xl mt-2 max-h-60 overflow-y-auto hidden"
      >
        {results.length > 0 ? (
          results.map((item, index) => (
            <div
              key={index}
              className="p-3 hover:bg-slate-100 cursor-pointer transition-all duration-200"
              onClick={() => onClickItem(item)}
            >
              <span className="capitalize text-sm">{renderItem(item)}</span>
            </div>
          ))
        ) : (
          <div className="p-2 text-gray-500 text-center text-sm">Sin datos</div>
        )}
      </div>
    </div>
  );
}

export default DebouncedSearch;